import { UserContext } from "contexts/UserContext"
import { useContext } from "react"
import VipFields from "./VipFields"
import NonVipFields from "./NonVipFields"

function ProfileFields() {
  const { isVipBrand } = useContext(UserContext)

  return (
    <div className="flex flex-col gap-4 overflow-auto max-h-[60vh] px-2">
      {isVipBrand && <VipFields />}
      {!isVipBrand && <NonVipFields />}
    </div>
  )
}

export default ProfileFields
